module.exports = __webpack_public_path__ + "img/support.440684a6.svg";